import styled from "styled-components";

export const NotElemetsMessage = styled.strong`
	display: block;
	text-align: center;
	color: black;
	font-size: 18px;
`;
